import { render, staticRenderFns } from "./PreAgentFactorPayment.vue?vue&type=template&id=fcf81f60&scoped=true"
import script from "./PreAgentFactorPayment.vue?vue&type=script&lang=js"
export * from "./PreAgentFactorPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf81f60",
  null
  
)

export default component.exports